import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
import { ToastService } from 'src/app/core/toast.service';
import { GetSupplyEnquiriesService } from '../../services/get-supply-enquiries.service';
import { PageEvent } from '@angular/material/paginator';
import { SupplyEnquiries } from '../../models/supply-enquiries';
import { Sort } from '@angular/material/sort';
@Component({
  selector: 'app-my-enquiries',
  templateUrl: './my-enquiries.component.html',
  styleUrls: ['./my-enquiries.component.scss'],
  animations: [
    trigger("openCloseFilter", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '0px', opacity: '0' })),
      transition("false <=> true", [animate(500)])
    ])
  ]
})
export class MyEnquiriesComponent implements OnInit {
  filterForm = this.fb.group({
    sort: [[{"created_at":"desc"}]],
    status: ['ACTIVE', [Validators.required]],
    search: ['', [Validators.required]],
    limit: [50, [Validators.required]],
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);
  /* --------------------------------- FIELDS -------------------------------- */
  // FILTER-FUNCTIONALITIES
  OpenFilter = false;
  displayedColumns: string[] = [
   //  'select',
    'sNo',
    'image',
    'supply_id',
    // 'supply_variant_id',
    'created_at',
    'name',
    'phone',
    'email',
    // 'type',
    // 'message',
    // 'attachments',
    'action'
  ];
  dataSource: MatTableDataSource<SupplyEnquiries>;
  statusWiseCount: any;
  selection = new SelectionModel<SupplyEnquiries>(true, []);
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private getSupplyEnquiriesService: GetSupplyEnquiriesService,
    private toast: ToastService
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filter => {
      this.dataSource = null;
      return this.getSupplyEnquiriesService.getSupplyEnquiries(filter);
    })).subscribe(([supply_enquiries, count]: [SupplyEnquiries[], number]) => {
      this.dataSource = new MatTableDataSource<SupplyEnquiries>(supply_enquiries);
      this.totalElements = count;
    });
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  filterToggle(): void {
    this.OpenFilter = !this.OpenFilter;
  }
  plusField() {
  }
  minusField() {
  }
  delete() {
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.dataSource) {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.dataSource) {
      this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: SupplyEnquiries): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }
  /* ------------------------------- FilterForm ------------------------------- */
  get search() {
    return this.filterForm.get('search');
  }
  get sort() {
    return this.filterForm.get('sort');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  changePage(e: PageEvent) {
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  /* sendReplyDialog(supply_enquiries: SupplyEnquiries){
    this.matDialog.open ( EnquireResponseComponent, {
      width: '50%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: supply_enquiries
    })
  }*/
    sortData(ev:Sort){
      if(!ev.direction){
        this.sort.setValue([{"created_at":"desc"}]);
        this.filterSubject.next(this.filterForm.value);
        return;
      }
      switch(ev.active){
        case "supply_id" :
          this.sort.setValue([ {"supply": {"name":ev.direction}}]);
          break;
        case "name" :
          this.sort.setValue([
            {"dental_supplier":{"name": ev.direction}},
            {"dental_practice":{"name": ev.direction}},
            {"dental_professional":{"name": ev.direction}}
          ]);
          break;
        case "email" :
          this.sort.setValue([
            {"dental_supplier":{"email": ev.direction}},
            {"dental_practice":{"email": ev.direction}},
            {"dental_professional":{"email": ev.direction}}
          ]);
          break;
        case "phone":
          this.sort.setValue([
            {"dental_supplier":{"phone": ev.direction}},
            {"dental_practice":{"phone": ev.direction}},
            {"dental_professional":{"phone": ev.direction}}
          ]);
          break;
        case "brand":
          this.sort.setValue([{"supply_brand":{"name": ev.direction}}]);
          break;
        default:
          this.sort.setValue([{"created_at":"desc"}]);
      }
      this.filterSubject.next(this.filterForm.value);
    }
}
